"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.upload = void 0;
const uuid_1 = require("uuid");
const aws_amplify_1 = require("aws-amplify");
async function upload(file) {
    if (!file)
        return;
    let expiryDate = new Date();
    expiryDate.setHours(expiryDate.getHours() + 1);
    const name = typeof file !== "string" ? file.name : "runtime";
    let key = `${name}-${uuid_1.v4()}`;
    await aws_amplify_1.Storage.put(key, file, {
        level: 'private',
        contentType: 'application/json',
        expires: expiryDate,
    });
    const result = await aws_amplify_1.Storage.get(key, {
        level: 'private',
        expires: 60 * 60, //sec
    });
    console.log(`Uploaded ${name} to`, result);
    return result;
}
exports.upload = upload;
//# sourceMappingURL=storage.js.map